import React from "react-dom/client";

const DataLoading = () => {
  return <>
    <h1>Loading...</h1>
  </>
}

export default DataLoading;